module.exports = __webpack_public_path__ + "img/warnings-02.d018e7cc.png";